import React from 'react';
import { connect } from 'react-redux';
import { Button, IconButton } from 'react-toolbox/lib/button';
import { get, remove, update } from '~/actions/locations';
// import Table from 'react-toolbox/lib/table';
import Spinner from '~/components/Spinner';
import styleDialog from '~/style/dialog.scss';
import styleLocal from './style.scss';

class Dialog extends React.Component {
  static contextTypes = {
    apiClient: React.PropTypes.object.isRequired,
    dialogPush: React.PropTypes.func.isRequired,
    dialogClose: React.PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      item: null,
      changes: {},
    };
  }

  componentDidMount() {
    get(this.props.dispatch, this.context.apiClient, this.props.data.id)
      .then(r => this.setState({ loading: false, item: r.data.location }))
      .catch(() => this.setState({ loading: false }));
  }

  submit() {
    return update(
      this.props.dispatch,
      this.context.apiClient,
      this.props.data.id,
      this.state.changes
    ).then(() => this.context.dialogClose(this.props.dialogId));
  }

  remove() {
    return remove(
      this.props.dispatch,
      this.context.apiClient,
      this.props.data.id
    ).then(() => this.context.dialogClose(this.props.dialogId))
      .then(() => this.props.data.onRemove && this.props.data.onRemove());
  }

  update() {
    update(this.props.dispatch, this.context.apiClient, this.props.data.id, this.state.edits)
      .then(() => this.setState({ edits: {} }));
  }

  render() {
    if (this.state.loading) {
      return (
        <div className={[styleDialog.background, styleDialog[this.props.transition]].join(' ')} onClick={() => this.context.dialogClose(this.props.dialogId)}>
          <div className={styleDialog.container} onClick={e => e.stopPropagation()}>
            <Spinner />
          </div>
        </div>
      );
    }
    if (!this.state.loading && !this.state.item) {
      return (
        <div className={[styleDialog.background, styleDialog[this.props.transition]].join(' ')} onClick={() => this.context.dialogClose(this.props.dialogId)}>
          <div className={styleDialog.container} onClick={e => e.stopPropagation()}>
            Not found
          </div>
        </div>
      );
    }
    return (
      <div className={[styleDialog.background, styleDialog[this.props.transition]].join(' ')} onClick={() => this.context.dialogClose(this.props.dialogId)}>
        <div className={styleDialog.container} onClick={e => e.stopPropagation()}>
          <IconButton className={styleDialog.closeButton} icon="close" onClick={() => this.context.dialogClose(this.props.dialogId)} />
          <div className={styleDialog.content}>
            <form onSubmit={e => { e.preventDefault(); this.submit(); }}>
              <div style={{ paddingBottom: '10px' }}>
                Name
                <input
                  style={{ marginLeft: '20px' }}
                  value={this.state.changes.name !== undefined
                    ? this.state.changes.name
                    : this.state.item.name}
                  onChange={e =>
                    this.setState({ changes: { ...this.state.changes, name: e.target.value } })}
                />
              </div>
              <Button
                className={styleLocal.buttonRemove}
                label="Delete"
                icon="clear"
                onClick={() => this.context.dialogPush('message', { content: 'Are you sure?', onConfirm: () => this.remove() })}
              />
              <Button label="Save" icon="done" type="submit" primary raised />
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default connect()(Dialog);



// WEBPACK FOOTER //
// ./app/dialogs/LocationEdit/index.js